import { useSelector } from 'react-redux';
import { CustomerType, selectCustomerType, selectDisplayCalculatedLaterCartLabel } from '@buy-viasat/redux/src/app';
import { selectCreditCheckComplete } from '@buy-viasat/redux/src/credit-verification';
import {
  NUMBERED_ROUTES,
  Routes,
  selectCurrentStepNumber,
  selectIsMaxRouteGreaterThanScheduleInstallation,
} from '@buy-viasat/redux/src/navigator';

export const useTotalPriceVisibility = (isBackgroundAPICallLoading?: boolean) => {
  const customerType = useSelector(selectCustomerType);
  const isBusinessUser = customerType === CustomerType.B;
  const isUSResidential = customerType === CustomerType.R;

  const isCreditCheckComplete = useSelector(selectCreditCheckComplete);
  const isCurrentRouteGreaterThanScheduleInstallation = useSelector(selectIsMaxRouteGreaterThanScheduleInstallation);
  const displayCalculatedLaterCartLabel = useSelector(selectDisplayCalculatedLaterCartLabel);
  const currentStepNumber = useSelector(selectCurrentStepNumber);

  const hasMovedPastCreditCheckStep = currentStepNumber > NUMBERED_ROUTES.indexOf(Routes.CREDIT_CHECK);
  // for Residential Customers, we should never display upfront fees before customer moves Past the Credit Check step, regardless of API response;

  const passesCreditVerificationCheck =
    isCreditCheckComplete && !displayCalculatedLaterCartLabel && hasMovedPastCreditCheckStep;

  const visible = isUSResidential
    ? passesCreditVerificationCheck
    : (isBusinessUser && !isBackgroundAPICallLoading) ||
      (passesCreditVerificationCheck && isCurrentRouteGreaterThanScheduleInstallation);

  return { visible };
};
